import { Route } from '@angular/router';
import { PAGE_TITLE_SUFFIX } from '../../app.constants';

import { UserRouteAccessService } from '../../shared';
import { FcAuthRedirectComponent } from './fc-auth-redirect.component';

export const fcAuthRedirectRoute: Route = {
  path: 'franceconnect/userinfo',
  component: FcAuthRedirectComponent,
  data: {
    needAuthentication: false,
    pageTitle: `France Connect${PAGE_TITLE_SUFFIX}`
  },
  canActivate: [UserRouteAccessService]
};



// WEBPACK FOOTER //
// ./src/main/webapp/app/account/fc-auth-redirect/fc-auth-redirect.route.ts